import controller from './packet.controller';

export default {
  bindings: {
    packet: '<'
  },
  controller,
  template: require('./packet.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/components/packet/packet.component.ts